export var UmbrellaOrganization;
(function (UmbrellaOrganization) {
    UmbrellaOrganization["ChiroNationaal"] = "ChiroNationaal";
    UmbrellaOrganization["ScoutsEnGidsenVlaanderen"] = "ScoutsEnGidsenVlaanderen";
    UmbrellaOrganization["KSA"] = "KSA";
    UmbrellaOrganization["KLJ"] = "KLJ";
    UmbrellaOrganization["FOS"] = "FOSOpenScouting";
    UmbrellaOrganization["JeugdRodeKruis"] = "JeugdRodeKruis";
    UmbrellaOrganization["JNM"] = "JNM";
    UmbrellaOrganization["Other"] = "Other";
})(UmbrellaOrganization || (UmbrellaOrganization = {}));
export class UmbrellaOrganizationHelper {
    static getName(umbrellaOrganization) {
        switch (umbrellaOrganization) {
            case UmbrellaOrganization.ChiroNationaal: return "Chirojeugd Vlaanderen";
            case UmbrellaOrganization.ScoutsEnGidsenVlaanderen: return "Scouts & Gidsen Vlaanderen";
            case UmbrellaOrganization.KSA: return "KSA";
            case UmbrellaOrganization.KLJ: return "KLJ";
            case UmbrellaOrganization.FOS: return "FOS Open Scouting";
            case UmbrellaOrganization.JeugdRodeKruis: return "Jeugd Rode Kruis";
            case UmbrellaOrganization.JNM: return "JNM";
            case UmbrellaOrganization.Other: return "Andere / geen";
        }
    }
    static getList() {
        const list = Object.values(UmbrellaOrganization);
        const ob = [];
        for (const item of list) {
            ob.push({
                name: this.getName(item),
                value: item
            });
        }
        return ob;
    }
}
//# sourceMappingURL=UmbrellaOrganization.js.map